import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// export const useCanonicalTag = () => {
//     const location = useLocation();
//     const currentPath = location.pathname;
//     const baseUrl = window.location.origin;

//     const updateCanonicalTag = () => {
//         const head = document.head;
//         const existingCanonical = document.querySelector('link[rel="canonical"]');
//         if (existingCanonical) {
//             head.removeChild(existingCanonical);
//         }

//         const canonicalUrl = `${baseUrl}${currentPath}`;
//         const link = document.createElement('link');
//         link.rel = 'canonical';
//         link.href = canonicalUrl;
//         head.appendChild(link);
//     };

//     useEffect(() => {
//         updateCanonicalTag();
//     }, [currentPath]);

//     return null;
// };

export const useCanonicalTag = () => {
    const location = useLocation();
  
    useEffect(() => {
      if (typeof window === 'undefined') return;
  
      const baseUrl = window.location.origin;
      const currentPath = location.pathname;
      const canonicalUrl = `${baseUrl}${currentPath}`;
  
      const head = document.head;
      const existingCanonical = document.querySelector('link[rel="canonical"]');
      if (existingCanonical) {
        head.removeChild(existingCanonical);
      }
  
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = canonicalUrl;
      head.appendChild(link);
    }, [location.pathname]);
  
    return null;
  };
